import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { Spin, Button, Modal, Popover } from "antd";
import { getThemeModalList } from "../../../../../services/activitySign/create";
import styles from "./index.less";

const ThemeModal = ({ maskId, onChange }) => {
  const [nowMaskId, setNowMaskId] = useState(maskId);
  const [loading, setLoading] = useState(false);
  const [themeList, setThemeList] = useState([]);
  const [themeModalState, setThemeModalState] = useState(false);

  useEffect(() => {
    setLoading(true);
    getThemeModalList()
      .then(res => {
        setLoading(false);
        setThemeList(res || []);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  // 点击选中活动蒙层时
  const handleChangeTheme = themeId => {
    if (themeId === nowMaskId) {
      setNowMaskId("");
    } else {
      setNowMaskId(themeId);
    }
  };

  // 设置当前modal状态
  const handleSetThemeModalState = state => {
    setThemeModalState(state);
    if (!state) {
      setNowMaskId("");
    }
  };

  // 弹框确定的回调
  const handleSelectTheme = () => {
    if (onChange) {
      setNowMaskId(nowMaskId);
      onChange(nowMaskId);
    }
    setThemeModalState(false);
  };

  // 渲染弹框内的每个蒙层
  const renderThemeItem = item => {
    const cls = classNames([
      "themeItemContainer",
      nowMaskId === item.id && "selectedThemeItem"
    ]);
    return (
      <div className={cls} onClick={() => handleChangeTheme(item.id)}>
        <img src={item.themeMask} alt="" />
      </div>
    );
  };

  // 渲染modal
  const renderModal = () => {
    const modalProps = {
      visible: themeModalState,
      title: "设置活动主题蒙层",
      onCancel: () => handleSetThemeModalState(false),
      className: "activity-theme-modal-container",
      onOk: handleSelectTheme
    };
    return (
      <Modal {...modalProps}>
        <div className="themeModalContainer">
          {themeList.map(item => {
            return renderThemeItem(item);
          })}
        </div>
      </Modal>
    );
  };

  // 示例弹框
  const renderDemoModal = () => {
    return (
      <div className="demoModalContainer">
        <div className="demoInfo">
          选择蒙层模版后，当前活动所有上传的图片均会添加默认的蒙层标识，如上传“图一”
          上传成功后，在动态页面展示的图为“图二”所示。
        </div>
        <div className="demoImg">
          <div className="imgContainer">
            <img
              src="https://nbugs-video.oss-cn-hangzhou.aliyuncs.com/activity/shili/1.jpg"
              alt=""
            />
            <span>图一</span>
          </div>
          <div className="arrow" />
          <div className="imgContainer">
            <img
              src="https://nbugs-video.oss-cn-hangzhou.aliyuncs.com/activity/shili/2.jpg"
              alt=""
            />
            <span>图二</span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.root}>
      <Spin spinning={loading}>
        <Button onClick={() => handleSetThemeModalState(true)}>
          {nowMaskId ? "修改" : "设置"}
        </Button>
        <div className="demoTip">
          点击查看
          <Popover
            content={renderDemoModal()}
            title=""
            placement="bottom"
            trigger="click"
            className="activity-theme-popover"
          >
            <span className="txt">示例</span>
          </Popover>
        </div>
      </Spin>
      {renderModal()}
    </div>
  );
};

export default ThemeModal;
